import { Route } from '@angular/router';
import { rootPaths } from './core/constants/paths';
import { PagenotfoundComponent } from './core/components/pagenotfound/pagenotfound.component';
import { LoginComponent } from './core/components/login/login.component';
import { provideStates } from '@ngxs/store';
import { OrderCaptureState } from './sales/states/order-capture/order-capture.state';
import { CustomerProductState } from './sales/states/customer-product/customer-product.state';
import { CustomerProductMbbState } from './sales/modules/mbb/states/customer-product-mbb.state';
import { CustomerProductHardwareState } from './sales/states/accessory-product/accessory-product.state';
import { CustomerProductMobilePhoneState } from './sales/states/customer-product-mobilephone/customer-product-mobilephone.state';
import { CustomerProductTradeInState } from './sales/states/customer-product-trade-in/customer-product-trade-in.state';
import { CustomerServiceProductState } from './sales/states/customer-service-product/customer-service-product.state';
import { LogisticsState } from './sales/states/logistics/logistics.state';
import { SaleState } from './sales/states/sale/sale.state';
import { MobilBytteState } from './sales/modules/mobilephone/states/mobilbytte/mobilbytte.state';
import { WarehouseState } from './sales/states/warehouse/warehouse.state';
import { OfferingMbbState } from './sales/states/offering-mbb/offering-mbb.state';
import { FamilyState } from './sales/states/family/family.state';
import { SupportState } from './support/states/support/support.state';
import { AuthorizationGuard } from './core/guards/authorization.guard';
import { VoucherState } from './sales/states/voucher/voucher.state';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: rootPaths.sales,
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: rootPaths.sales,
    loadChildren: () => import('./sales/sales-routes').then(m => m.salesRoutes),
    providers: [
      provideStates([
        OrderCaptureState,
        CustomerProductState,
        CustomerProductMbbState,
        CustomerProductHardwareState,
        CustomerProductMobilePhoneState,
        CustomerProductTradeInState,
        CustomerServiceProductState,
        LogisticsState,
        SaleState,
        MobilBytteState,
        VoucherState,
        WarehouseState,
        OfferingMbbState,
        FamilyState,
      ]),
    ],
    canActivate: [AuthorizationGuard],
  },
  {
    path: rootPaths.support,
    loadChildren: () => import('./support/support-routes').then(m => m.supportRoutes),
    providers: [provideStates([SupportState])],
    data: { breadcrumb: '' },
    canActivate: [AuthorizationGuard],
  },
  {
    path: '**',
    pathMatch: 'full',
    component: PagenotfoundComponent,
    data: { title: 'Finner ikke siden' },
  },
];
